(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lvdg-seal-detail"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';
  const headingIcons = new Map([
    ['articles','📚'],['items','📚'],['client','👤'],['customer','👤'],
    ['contact','✉️'],['livraison','📦'],['shipping','📦'],
    ['calendrier de facturation','📅'],['billing schedule','📅'],
    ['moyen de paiement','💳'],['payment method','💳'],
    ['coût de livraison','🚚'],['delivery cost','🚚']
  ]);
  const actionIcons = new Map([
    ['modifier','✏️'],['edit','✏️'],['appliquer','🏷️'],['apply','🏷️'],
    ['passer une nouvelle commande','🛒'],['place order now','🛒'],
    ['réactiver','▶️'],['reactivate','▶️'],['reprendre','▶️'],['resume','▶️'],
    ['suspendre','⏸️'],['pause','⏸️'],['annuler','⛔'],['cancel','⛔']
  ]);
  function normal(text) { return text.trim().replace(/\s*:\s*$/, '').toLocaleLowerCase(); }
  function icon(element, value) {
    if (element.querySelector('.lvdg-detail-icon')) return;
    const span = document.createElement('span');
    span.className = 'lvdg-detail-icon';
    span.setAttribute('aria-hidden', 'true');
    span.textContent = value;
    element.prepend(span);
  }
  function decorate() {
    document.querySelectorAll('.seal-subscription-page:not([data-seal-subscriptions-list-page])').forEach(function (root) {
      root.querySelectorAll('h2,h3,h4').forEach(function (heading) {
        const value = headingIcons.get(normal(heading.textContent));
        if (value) icon(heading, value);
      });
      root.querySelectorAll('a,button').forEach(function (button) {
        if (button.querySelector('.lvdg-detail-icon')) return;
        const label = normal(button.textContent);
        const value = actionIcons.get(label);
        if (!value) return;
        button.classList.add('lvdg-detail-action');
        if (label === 'annuler' || label === 'cancel') button.classList.add('lvdg-detail-danger');
        icon(button, value);
      });
      root.querySelectorAll('span').forEach(function (span) {
        if (span.children.length || span.classList.contains('lvdg-detail-status')) return;
        const label = normal(span.textContent);
        if (!['suspendu','paused','actif','active'].includes(label)) return;
        span.classList.add('lvdg-detail-status');
        if (label === 'actif' || label === 'active') span.classList.add('lvdg-detail-status--active');
      });
    });
  }
  function init() {
    const main = document.getElementById('MainContent');
    if (!main) return;
    let scheduled = false;
    new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () { scheduled = false; decorate(); });
    }).observe(main, {childList:true,subtree:true});
    decorate();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lvdg-seal-portal"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';
  if (!location.pathname.replace(/\/+$/, '').endsWith('/a/subscriptions/manage')) return;
  const copyElement = document.getElementById('lvdg-seal-copy');
  if (!copyElement) return;
  let copy;
  try { copy = JSON.parse(copyElement.textContent); } catch (_) { return; }
  const main = document.getElementById('MainContent');
  if (!main) return;
  const panelUrl = '/pages/mon-abonnement';
  const calendarUrl = '/pages/calendrier-prelevements-abonnement';
  const accountUrl = 'https://account.lesvapeursdugrimoire.com/orders';
  function make(tag, className, text) {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (text) element.textContent = text;
    return element;
  }
  function link(text, href, className) {
    const element = make('a', className, text);
    element.href = href;
    return element;
  }
  function statusFor(text) {
    const match = text.match(/(?:statut|status)\s*:\s*(suspendu|suspended|paused|en pause|actif|active|annul[ée]|cancelled|canceled|expired|expir[ée]|arr[êe]t[ée])/i);
    if (!match) return 'unknown';
    const value = match[1].toLowerCase();
    if (/suspend|paused|en pause/.test(value)) return 'paused';
    if (/actif|active/.test(value)) return 'active';
    return 'cancelled';
  }
  function contractLinks(root) {
    return Array.from(root.querySelectorAll('a[href]')).filter(function (a) {
      if (!/^#\s*\d+$/.test(a.textContent.trim())) return false;
      try {
        const url = new URL(a.getAttribute('href'), location.href);
        return url.origin === location.origin && url.pathname.indexOf('/a/subscriptions') !== -1;
      } catch (_) { return false; }
    });
  }
  function findCard(anchor, root) {
    let candidate = anchor.parentElement;
    while (candidate && candidate !== root) {
      const text = candidate.innerText;
      if (text && /(?:statut|status)\s*:/i.test(text) && contractLinks(candidate).length === 1) return candidate;
      candidate = candidate.parentElement;
    }
    return null;
  }
  function addHeading(root) {
    const nativeHeading = root.querySelector('h1');
    if (nativeHeading) {
      nativeHeading.classList.add('lvdg-seal-native-title');
      const nativeGroup = nativeHeading.closest('.seal-layout');
      if (nativeGroup && nativeGroup.textContent.trim() === nativeHeading.textContent.trim()) nativeGroup.hidden = true;
    }
    const header = make('header', 'lvdg-seal-header');
    const nav = make('nav', 'lvdg-seal-nav');
    nav.setAttribute('aria-label', copy.back);
    nav.append(link('← ' + copy.back, panelUrl), link(copy.calendar, calendarUrl));
    header.append(nav, make('p', 'lvdg-seal-kicker', copy.kicker), make('h1', '', copy.heading), make('p', 'lvdg-seal-intro', copy.intro));
    root.prepend(header);
    const help = make('section', 'lvdg-seal-help');
    const title = make('h2', '', copy.help);
    title.id = 'lvdg-seal-help-title';
    help.setAttribute('aria-labelledby', title.id);
    help.append(title);
    [['faqDate', 'faqDateBody'], ['faqAction', 'faqActionBody'], ['faqPause', 'faqPauseBody']].forEach(function (keys) {
      const detail = make('details');
      detail.append(make('summary', '', copy[keys[0]]), make('p', '', copy[keys[1]]));
      help.append(detail);
    });
    help.append(link(copy.contact, '/pages/contact', 'lvdg-seal-contact'));
    root.append(help);
  }
  function enhanceSignedOut(root) {
    const native = root.querySelector('.seal-not-logged-in');
    if (!native || root.querySelector('.lvdg-seal-signin')) return;
    const section = make('section', 'lvdg-seal-signin');
    section.append(make('h2', '', copy.signedOut), make('p', '', copy.signedOutBody), link(copy.signIn, accountUrl, 'lvdg-seal-primary'));
    native.insertAdjacentElement('afterend', section);
    native.hidden = true;
  }
  function enhanceCard(anchor, root) {
    const card = findCard(anchor, root);
    if (!card || card.dataset.lvdgSealCard) return false;
    const text = card.innerText;
    const status = statusFor(text);
    card.dataset.lvdgSealCard = 'true';
    card.dataset.lvdgSealStatus = status;
    card.dataset.lvdgSealSearch = text.toLocaleLowerCase();
    card.classList.add('lvdg-seal-card');
    anchor.classList.add('lvdg-seal-number');
    anchor.setAttribute('aria-label', copy.identifier + ' ' + anchor.textContent.trim());
    if (status === 'paused') card.classList.add('lvdg-seal-card--paused');
    const actions = make('div', 'lvdg-seal-card-actions');
    const button = link(copy.open, anchor.getAttribute('href'), 'lvdg-seal-primary');
    button.setAttribute('aria-label', copy.open + ' ' + anchor.textContent.trim());
    actions.append(button);
    const explanation = make('details', 'lvdg-seal-status-help');
    explanation.append(make('summary', '', status === 'paused' ? copy.pausedTitle + ' — ' + copy.statusHelp.toLocaleLowerCase() : copy.statusHelp), make('p', '', copy[status]));
    actions.append(explanation);
    card.append(actions);
    return true;
  }
  function updateControls(root) {
    const cards = Array.from(root.querySelectorAll('[data-lvdg-seal-card]'));
    let toolbar = root.querySelector('.lvdg-seal-toolbar');
    if (cards.length < 2) {
      if (toolbar) toolbar.remove();
      cards.forEach(function (card) { card.hidden = false; });
      return;
    }
    if (toolbar) return;
    toolbar = make('section', 'lvdg-seal-toolbar');
    const searchLabel = make('label', '', copy.search);
    const search = make('input');
    search.type = 'search';
    search.placeholder = copy.searchHint;
    searchLabel.append(search);
    const filterLabel = make('label', '', copy.filter);
    const select = make('select');
    [['all', 'all'], ['active', 'activeFilter'], ['paused', 'pausedFilter'], ['cancelled', 'stoppedFilter']].forEach(function (entry) {
      const option = make('option', '', copy[entry[1]]);
      option.value = entry[0];
      select.append(option);
    });
    filterLabel.append(select);
    const count = make('p', 'lvdg-seal-count');
    count.setAttribute('role', 'status');
    count.setAttribute('aria-live', 'polite');
    toolbar.append(searchLabel, filterLabel, count);
    root.querySelector('.lvdg-seal-header').insertAdjacentElement('afterend', toolbar);
    function filterCards() {
      let visible = 0;
      const term = search.value.trim().toLocaleLowerCase();
      root.querySelectorAll('[data-lvdg-seal-card]').forEach(function (card) {
        const matches = (!term || card.dataset.lvdgSealSearch.indexOf(term) !== -1) && (select.value === 'all' || card.dataset.lvdgSealStatus === select.value);
        card.hidden = !matches;
        if (matches) visible++;
      });
      const message = visible ? visible + ' ' + copy.count : copy.empty;
      if (count.textContent !== message) count.textContent = message;
    }
    search.addEventListener('input', filterCards);
    select.addEventListener('change', filterCards);
    filterCards();
  }
  function enhance() {
    const root = main.querySelector('.seal-subscription-page');
    if (!root) return;
    if (!root.dataset.lvdgSealUx) {
      root.dataset.lvdgSealUx = 'true';
      addHeading(root);
    }
    enhanceSignedOut(root);
    let changed = false;
    contractLinks(root).forEach(function (anchor) { changed = enhanceCard(anchor, root) || changed; });
    if (changed) updateControls(root);
  }
  let scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () { scheduled = false; enhance(); });
  }
  const observer = new MutationObserver(schedule);
  observer.observe(main, {childList:true, subtree:true, characterData:true});
  document.addEventListener('sealsubs_portal:loaded', schedule);
  enhance();
})();
  } catch(e) { console.error(e); }
})();

})();
